'use strict';

// Import Libraries
import React from 'react';
import ReactDOM from 'react-dom';
import createReactClass from 'create-react-class';
import classNames from 'classnames';

// -----------------------------------------------------------
//  ProgressButton
// -----------------------------------------------------------
const ProgressButton = createReactClass({
  getInitialState() {
    return {
      spin: false
    };
  },
  render() {
    const $body = this.state.spin
      ? (
        <b
          className='btn-progress-spinner'
          style={{ width: this.width, height: this.height }}>
          <b className='btn-progress-spinner-icon' />
        </b>
      )
      : this.props.children;

    var { onTimeout, timeoutMs, ...additionalAttributes } = this.props;

    return (
      <div className='btn-block'>
        <a
          {...additionalAttributes}
          className={classNames(this.props.className, { 'btn-progress': this.state.spin, disabled: this.props.disabled })}
          href={this.props.href || '#'}
          onClick={this.handleClick}
        >
          {$body}
        </a>
      </div>

    );
  },
  handleClick(e) {
    if (typeof window !== 'undefined' && e === undefined) {
      e = window.event;
    }

    if (typeof e === 'object') {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (e.button === 0) {
        this.spin();
        if (this.props.timeoutMs && this.props.onTimeout) {
          setTimeout(() => this.props.onTimeout(this), this.props.timeoutMs);
        }
        this.props.onClick && this.props.onClick(e, this);
      }
    }
  },
  spin() {
    var $element = $(ReactDOM.findDOMNode(this));
    this.width = $element.outerWidth();
    this.height = $element.outerHeight();

    this.setState({ spin: true });
  },
  reset() {
    this.setState({ spin: false });
  }
});

export default ProgressButton;
